import { render } from "./AccountProfile.vue?vue&type=template&id=09a1c132"
import script from "./AccountProfile.vue?vue&type=script&lang=js"
export * from "./AccountProfile.vue?vue&type=script&lang=js"

import "./AccountProfile.vue?vue&type=style&index=0&id=09a1c132&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__